module.exports = __webpack_public_path__ + "img/patients_what-happens_2.86bee0dc.png";